import { createContext, useContext } from 'react';

/**
 * Lets render-block components call back into the chat — the rendered spec is
 * data, but a click needs to drive the agent: a follow-up chip sends a new
 * prompt (`onPrompt`), and a clarifying-question option (`ask_question` HITL)
 * submits an input response that resumes the parked turn (`onAnswer`).
 */
export interface ChatActions {
  onPrompt: (prompt: string) => void;
  /** Answer a pending HITL input request: pass the chosen option id, a freeform
   *  text answer, or both, for the request identified by `requestId`. */
  onAnswer: (requestId: string, optionId?: string, text?: string) => void;
}

export const ChatActionsContext = createContext<ChatActions>({
  onPrompt: () => {},
  onAnswer: () => {},
});

export const useChatActions = () => useContext(ChatActionsContext);
